exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-dialog[data-v-2041e57c] .md-dialog-container{max-width:90vw;max-height:140vw}.scroll-modal[data-v-2041e57c]{overflow:scroll;height:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2041e57c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/AdditionalsDialog.vue
// module id = 464
// module chunks = 0